import {Component, OnInit, ViewChild} from '@angular/core';
import {IonInput, ModalController} from '@ionic/angular';
import {AvanzamentoService} from '../../_services/avanzamento.service';
import {CampiUtenteService} from '../../_services/campi-utente.service';
import {CampiUtenteFormComponent} from '../campi-utente-form/campi-utente-form.component';
import { CampoUtenteDef } from '../../_models/CampoUtenteDef';
import { EntitaCampoUtente } from '../../_models/generated/entita-campo-utente';
import {LocalService} from '../../_services/local.service';
import {EventiService} from '../../_services/eventi.service';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {Lavorazione, Ordine, Risorsa} from '../../_models/_Index';
import {StatoEnum} from '../../_models/generated/stato-enum';
import {TipoRisorsa} from '../../_models/generated/tipo-risorsa';
import {MessageConfirm} from '../../_helpers/message-confirm.service';
import {SaveMessage} from '../../_helpers/save-message';
import {constants} from '../../_helpers/constants';
import {AuthenticationService} from '../../_services/authentication.service';
import {ArticoloEsolver} from "../../_models/ArticoloEsolver";
import {ArticoloCoeff} from "../../_models/ArticoloCoeff";
import {LicenzeService} from "../../_services/licenze.service";
import {ArticoliService} from "../../_services/articoli.service";
import {OrdineGroup} from '../../_models/OrdineGroup';
import {OrdineKey} from '../../_models/Ordine';
import {FaseCorrenteRef, FasePrecedenteAperta, FineConPrecedentiResult} from '../../_models/FasePrecedenteAperta';
import {chiaviPreselezionate} from '../../interfaccia-manuale/interfaccia-manuale-chiudi-fasi/interfaccia-manuale-chiudi-fasi.component';
import {descriviFasiNonChiuse} from '../../_helpers/esiti-chiusura-fasi';

/** Quanto l'interruttore «Aggiorna fasi riga» modifica nella modale, per ripristinarlo allo spegnimento. */
interface StatoPrimaInterruttore {
  aggTerminato: boolean;
  aggStato: StatoEnum;
  statoPrimaDelTerminato: StatoEnum;
  aggElimina: boolean;
  autoEliminaByTarget: boolean;
  autoEliminaByStato: boolean;
  quantita: QuantitaModale;
}

interface QuantitaModale {
  aggQtaLav: number;
  aggQtaLavUdM2: number;
  aggQtaScar: number;
  aggQtaScarUdM2: number;
  aggQtaNc: number;
  aggQtaNcUdM2: number;
}

@Component({
  selector: 'app-ordini-update-send',
  templateUrl: './ordini-update-send.component.html',
  styleUrls: ['./ordini-update-send.component.scss'],
  standalone: false
})
export class OrdiniUpdateSendComponent implements OnInit {
  ordine: Ordine;
  loadTempo = false;
  tempoLoading = false;
  dataOrdine = new Date();
  aggTerminato: boolean;
  // Feature 151: «Aggiorna fasi riga» = Termina con chiusura delle righe/fasi a monte (procedura 130).
  aggTerminatoRiga = false;
  fasiPrecedenti: FasePrecedenteAperta[] = [];
  fasiPrecedentiSelezionate: OrdineKey[] = [];
  letturaFasiInCorso = false;
  viewElimina = true;
  aggElimina = false;
  aggQtaLav: number;
  aggQtaLavUdM2: number;
  aggQtaScar: number;
  aggQtaScarUdM2: number;
  aggQtaNc: number;
  aggQtaNcUdM2: number;
  aggLottoScarico = '';
  scartoMode = 0;
  loading = false;
  changeStato = false;
  changeFlagTerminato = false;
  toSend = false;
  isEsolverOrg = false;
  autoEliminaByTarget = false;
  autoEliminaByStato = false;
  canAutoRemoveFromMes = false;
  StatoEnum = StatoEnum;
  TipoRisorsa = TipoRisorsa;
  // Lucchetto quantità ordine: sblocco esplicito della modifica quando il valore è basato su ESOLVER.
  quantitaUnlocked = false;
  @ViewChild('quantitaInputRef') quantitaInputRef: IonInput;
  // Conversione automatica tra le due UdM tramite coefficiente articolo (stessa logica di UdmConverterComponent).
  articoloCoeff: ArticoloCoeff | null = null;
  conversioneAutomatica = true;
  // Feature 105: campi utente OdP (definizioni LocalApi + hint valori ESOLVER per documento).
  campiUtenteAttivi: CampoUtenteDef[] = [];
  campiUtenteStorici: CampoUtenteDef[] = [];
  valoriEsolverDoc: Record<string, string> | null = null;
  @ViewChild(CampiUtenteFormComponent) campiUtenteForm?: CampiUtenteFormComponent;
  protected readonly constants = constants;
  // JSON consolidato all'uscita dal tab info (il form vive sotto *ngIf e viene distrutto);
  // undefined = campi utente mai renderizzati/toccati → nessun salvataggio necessario.
  private pendingCampiUtente?: string;
  // riceve un'istanza condivisa o se loadTempo sostituisce this.ordine durante il caricamento.
  private ordineOriginale: Ordine;
  private qtaLavorataOriginale: number;
  private statoPrimaDelTerminato: StatoEnum;
  // Quantità come lette all'apertura: il getter qtaAvanzamento ribasa ordine.quantitaLavorata.
  private quantitaLette: QuantitaModale;
  private statoPrimaInterruttore: StatoPrimaInterruttore | null = null;

  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    private messageConfirm: MessageConfirm,
    private saveMessage: SaveMessage,
    private modalCtrl: ModalController,
    private avanzamentoService: AvanzamentoService,
    private campiUtenteService: CampiUtenteService,
    private localService: LocalService,
    private eventiService: EventiService,
    private articoliService: ArticoliService,
    private organizzazioniService: OrganizzazioniService) { }

  private _currentTab = 'avanza';

  get currentTab(): string {
    return this._currentTab;
  }

  set currentTab(value: string) {
    if (this._currentTab === 'info' && value !== 'info' && this.campiUtenteForm) {
      this.pendingCampiUtente = this.campiUtenteForm.serialize() ?? '{}';
      this.ordine.campiUtente = this.pendingCampiUtente;
    }
    if (value === 'qta' && this._currentTab !== 'qta') {
      // l'articolo/UdM possono essere stati cambiati nel tab 'info': ricarica il coefficiente.
      this.loadArticoloCoeff();
    }
    this._currentTab = value;
  }

  private _aggStato: StatoEnum;

  get aggStato(): StatoEnum {
    return this._aggStato;
  }

  set aggStato(value: StatoEnum) {
    this._aggStato = value;
    this.syncAutoRemoveState();
  }

  get qtaAvanzamento() {
    return this.deltaAvanzamento(this.leggiQuantita());
  }

  get qtaScartoAvanzamento() {
    if (this.scartoMode === 1 || this.scartoMode === 2) {
      return 0;
    }
    return +this.aggQtaScar - this.ordine.quantitaScartata;
  }

  get showAutoEliminaWarning(): boolean {
    return this.aggElimina && (this.autoEliminaByTarget || this.autoEliminaByStato);
  }

  // Colore della card "Quantità per avanzamento": è il primo binding del template a essere valutato
  // in quella card (prima di {{qtaAvanzamento}} più in basso), quindi forza qui la stessa lettura
  // — che ribasa ordine.quantitaLavorata come side-effect, idempotente — PRIMA del confronto.
  // Altrimenti [color] vedrebbe valori diversi tra il primo passaggio di CD e la verifica
  // checkNoChanges (ExpressionChangedAfterItHasBeenCheckedError), perché il ribasamento avverrebbe
  // solo dopo, quando il template arriva a leggere qtaAvanzamento.
  get quantitaAvanzamentoCardColor(): string {
    void this.qtaAvanzamento;
    return (this.ordine.quantitaLavorata !== this.aggQtaLav || this.ordine.quantitaNonConforme !== this.aggQtaNc) ? 'warning' : '';
  }

  /**
   * Perché l'interruttore «Aggiorna fasi riga» non si può accendere, oppure `null`. Legge i valori
   * dell'ordine come aperto: la modale li modifica solo al salvataggio.
   */
  get motivoBloccoInterruttore(): string | null {
    if (!this.organizzazioniService.chiudiFasiPrecedenti) {
      return 'Richiede l\'opzione "Chiudi fasi precedenti"';
    }
    if (this.ordine.flgTerminato) {
      return 'Fase già terminata';
    }
    const sospesi = (this.ordine.quantitaLavorataWait ?? 0) + (this.ordine.quantitaScartataWait ?? 0) +
      (this.ordine.quantitaNonConformeWait ?? 0);
    if (sospesi > 0) {
      return 'Ci sono avanzamenti sospesi.';
    }
    // La chiusura non invia il delta locale non ancora arrivato a ESOLVER: andrebbe perso.
    if (this.quantitaLette && this.deltaAvanzamento(this.quantitaLette) > 0) {
      return 'Ci sono quantità da inviare: fare prima INVIO ESOLVER con l\'interruttore spento.';
    }
    return null;
  }

  /** Con l'interruttore acceso e almeno una fase scelta, l'invio passa dalla procedura 130. */
  get chiusuraConFasiPrecedenti(): boolean {
    return this.aggTerminatoRiga && this.fasiPrecedentiSelezionate.length > 0;
  }

  get coeffMismatch(): boolean {
    if (this.conversioneAutomatica || !this.articoloCoeff || !this.ordine.udM2) {
      return false;
    }
    if (this.ordine.quantita == null || this.ordine.quantitaOrdinataUdM2 == null) {
      return false;
    }
    return Math.abs(this.ordine.quantita * this.articoloCoeff.coeffMagToDes - this.ordine.quantitaOrdinataUdM2) >= (1 / 10) * this.articoloCoeff.numDecUm2;
  }

  ngOnInit() {
    this.ordineOriginale = this.ordine;
    this.qtaLavorataOriginale = this.ordine.quantitaLavorata;
    if (this.loadTempo) {
      // Percorso legacy/difensivo: se il dettaglio viene caricato dopo l'apertura,
      // lavoriamo subito su una copia per non sporcare l'istanza ricevuta.
      this.ordine = {...this.ordine};
    }
    this.setupOrdineFields();
    this.loadCampiUtente();
    if (this.loadTempo) {
      this.getOrdineTempo();
    }
  }

  setOrdineField() {
    const isTargetReached = this.ordine.quantitaLavorata + this.ordine.quantitaNonConforme >= this.ordine.quantita;

    if (this.ordine.flgTerminato) {
      this.aggTerminato = this.ordine.flgTerminato;
    } else {
      this.aggTerminato = isTargetReached;
    }

    this.viewElimina = this.ordine.statoElimina == 0;
    this.aggStato = this.ordine.stato;
    this.statoPrimaDelTerminato = this.aggStato;
    if (this.aggTerminato) {
      this.aggStato = StatoEnum.TERMINATO;
    }
    this.refreshAutoRemoveState();
    this.aggQtaLav = this.ordine.quantitaLavorata;
    this.aggQtaScar = this.ordine.quantitaScartata;
    this.aggQtaNc = this.ordine.quantitaNonConforme;
    this.quantitaLette = this.leggiQuantita();
  }

  updateSelArticolo = (articolo: ArticoloEsolver) => this.ordine.descArticolo = articolo.desArt;

  cancel = () => {
    this.ordineOriginale.quantitaLavorata = this.qtaLavorataOriginale;
    void this.modalCtrl.dismiss(false, 'cancel');
  };

  updateTerminato(terminato: boolean) {
    this.aggTerminato = terminato;
    if (terminato) {
      if (this.aggStato !== StatoEnum.TERMINATO) {
        this.statoPrimaDelTerminato = this.aggStato;
      }
      this.aggStato = StatoEnum.TERMINATO;
      return;
    }

    this.aggStato = this.statoPrimaDelTerminato;
    this.aggElimina = false;
    this.autoEliminaByTarget = false;
    this.autoEliminaByStato = false;
  }

  getOrdineTempo() {
    this.tempoLoading = true;
    this.localService.getOrdiniTempoAsync(this.ordine.organizzazioneId, this.ordine.idDocumento, this.ordine.idRiga, this.ordine.idRigaLavorazione)
      .then((_ordine: Ordine) => {
        this.ordine = _ordine;
        this.setupOrdineFields();
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dell'ordine."))
      .finally(() => this.tempoLoading = false);
  }

  /**
   * Feature 151: accendere l'interruttore legge le righe/fasi a monte della fase e le mostra sotto, con
   * le preselezioni della feature 130; spegnerlo ripristina la modale com'era.
   */
  async changeTerminatoRiga(attivo: boolean) {
    if (!attivo) {
      this.ripristinaDaInterruttore();
      return;
    }
    if (this.motivoBloccoInterruttore) {
      this.ripristinaDaInterruttore();
      return;
    }
    this.letturaFasiInCorso = true;
    const fasi = await this.leggiFasiPrecedenti();
    this.letturaFasiInCorso = false;
    // Spento durante la lettura: l'utente ha già cambiato idea.
    if (!this.aggTerminatoRiga) {
      return;
    }
    if (fasi === null || fasi.length === 0) {
      this.avvisaElencoNonDisponibile(fasi);
      this.ripristinaDaInterruttore();
      return;
    }
    this.attivaInterruttore(fasi);
  }

  changeRisorsa = (risorsa: Risorsa) => {
    this.ordine.risorsa = risorsa;
    this.refreshAutoRemoveState();
  };

  changeLavorazione = (lavorazione: Lavorazione) => this.ordine.lavorazione = lavorazione;

  updateLocalOrdine(ordine: Ordine) {
    const isReopenFromTerminato = ordine.flgTerminato && !this.aggTerminato;
    const isReactivatingToMachine =
      this.aggStato === StatoEnum.LANCIATO || this.aggStato === StatoEnum.PIANIFICATO;
    ordine.stato = this.aggStato;
    ordine.flgTerminato = this.aggTerminato;
    if (this.viewElimina && this.aggElimina && ordine.statoElimina === 0 && this.canRemoveFromMes(ordine)) {
      ordine.statoElimina = 1;                       // richiesta "togli da MES" (precedenza)
    } else if (isReopenFromTerminato || isReactivatingToMachine) {
      ordine.statoElimina = 0;                       // riattivazione a stato scrivibile → pulisci il flag delete
    }
    // else: preserva il valore corrente (un avanzamento qty su ordine già ELIMINATO non lo "resuscita")
    ordine.quantitaLavorataWait = +this.aggQtaLav - ordine.quantitaLavorata;
    ordine.quantitaScartataWait = +this.aggQtaScar - ordine.quantitaScartata;
    ordine.quantitaNonConformeWait = +this.aggQtaNc - ordine.quantitaNonConforme;
    if (this.scartoMode === 1) { // detratto per invio
      ordine.quantitaLavorataWait -= ordine.quantitaScartataWait;
      ordine.quantitaScartataWait = 0;
    }
    if (this.scartoMode === 2) { // escluso da invio
      ordine.quantitaScartataWait = 0;
    }
    ordine.quantitaLavorata = +this.aggQtaLav;
    ordine.quantitaScartata = +this.aggQtaScar;
    ordine.quantitaNonConforme = +this.aggQtaNc;
  }

  checkChanges() {
    if (this.ordine.stato !== this.aggStato) {
      this.changeStato = true;
    }
    if (this.ordine.flgTerminato !== this.aggTerminato && this.aggTerminato) {
      this.changeFlagTerminato = true;
    }
  }

  async save() {
    this.loading = true;
    if (!await this.saveCampiUtente()) {
      this.loading = false;
      return;
    }
    this.checkChanges();
    this.toSend = false;
    this.saveOrdine(this.ordine);
  }

  saveOrdine(ordine: Ordine) {
    this.updateLocalOrdine(ordine);
    this.localService.updateOrdine(ordine)
      .then(() => this.creaEventoStato(ordine))
      .finally(() => this.loading = false);
  }

  creaEventoStato(ordine: Ordine) {
    this.loading = true;
    if (this.changeStato) {
      this.eventiService.creaEvento(this.aggStato, ordine, new Date())
        .then(() => this.creaEventoFlagTerminato(ordine))
        .finally(() => this.loading = false);
    } else {
      this.creaEventoFlagTerminato(ordine);
    }
  }

  creaEventoFlagTerminato(ordine: Ordine) {
    if (this.changeFlagTerminato) {
      this.eventiService.creaEvento(StatoEnum.TERMINATO, ordine, new Date())
        .then(() => this.dismiss())
        .finally(() => this.loading = false);
    } else {
      this.dismiss();
    }
  }

  dismiss() {
    if (this.toSend) {
      void this.modalCtrl.dismiss(true, 'send');
    } else {
      void this.modalCtrl.dismiss(true, 'save');
    }
  }

  async send() {
    this.loading = true;
    if (!await this.saveCampiUtente()) {
      this.loading = false;
      return;
    }
    if (this.chiusuraConFasiPrecedenti) {
      await this.inviaConFasiPrecedenti();
      return;
    }
    this.checkChanges();
    this.toSend = true;
    this.sendOrdine(this.ordine);
  }

  sendOrdine(ordine: Ordine) {
    this.loading = true;
    this.updateLocalOrdine(ordine);
    this.localService.updateOrdine(ordine)
      .then(() => this.avanzamentoService
        .invioFileEsolverFromOrdine(ordine, this.dataOrdine, this.organizzazioniService.currentOrganizzazioneValue,
          this.aggLottoScarico, false))
      .then(() => this.creaEventoStato(ordine))
      .catch(() => {
        this.saveMessage.messageError("Ci sono problemi con l'invio del file.");
        void this.modalCtrl.dismiss(true, 'error');
      })
      .finally(() => this.loading = false);
  }

  deleteOrdine = async (ordine: Ordine) => {
    let confirmed = false;
    try {
      confirmed = await this.messageConfirm.presentAlert(`Confermi di eliminare l'ordine ${ordine.numRegistrazione} ` +
        `(${ordine.idDocumento}.${ordine.idRiga}.${ordine.idRigaLavorazione}) e tutti gli eventi collegati?`, () => {});
    } catch {
      this.saveMessage.messageError("Ci sono problemi con la conferma di eliminazione dell'ordine.");
      return;
    }

    if (!confirmed) {
      return;
    }

    this.loading = true;
    try {
      await this.localService.deleteOrdineAsync(this.organizzazioniService.organizzazioneId, ordine.idDocumento,
        ordine.idRiga, ordine.idRigaLavorazione);
      this.ordine.onQueue = true;
      this.localService.markOrdineDeletePending(ordine);
      this.saveMessage.messageInfo("Richiesta di eliminazione dell'ordine inviata con successo.", true);
      void this.modalCtrl.dismiss(true, 'delete');
    } catch {
      this.saveMessage.messageError("Ci sono problemi con l'eliminazione dell'ordine.");
    } finally {
      this.loading = false;
    }
  };

  async toggleQuantitaLock() {
    this.quantitaUnlocked = !this.quantitaUnlocked;
    if (!this.quantitaUnlocked) {
      return;
    }
    setTimeout(() => this.quantitaInputRef?.setFocus(), 0);
  }

  toggleConversioneAutomatica() {
    this.conversioneAutomatica = !this.conversioneAutomatica;
    if (this.conversioneAutomatica) {
      // riallinea subito la UdM2 alla UdM1 corrente quando si riattiva la sincronizzazione.
      this.onQuantitaChange(this.ordine.quantita);
    }
  }

  onQuantitaChange(value: number) {
    this.ordine.quantita = value;
    if (this.conversioneAutomatica && this.ordine.udM2 && this.articoloCoeff) {
      this.ordine.quantitaOrdinataUdM2 = this.round(value * this.articoloCoeff.coeffMagToDes, this.articoloCoeff.numDecUm2);
    }
  }

  onQuantitaUdM2Change(value: number) {
    this.ordine.quantitaOrdinataUdM2 = value;
    if (this.conversioneAutomatica && this.articoloCoeff) {
      this.ordine.quantita = this.round(value / this.articoloCoeff.coeffMagToDes, this.articoloCoeff.numDecUmMag);
    }
  }

  // Feature 105: definizioni attive + storiche (disattivate con valore presente resi read-only
  // dal form) e valori ESOLVER per documento (hint best-effort, errori silenziati).
  private loadCampiUtente() {
    const orgId = this.organizzazioniService.organizzazioneId;
    if (!orgId) return;

    this.campiUtenteService.getDefinizioni(orgId, false, EntitaCampoUtente.ORDINE_PRODUZIONE)
      .then(defs => {
        this.campiUtenteAttivi = (defs ?? []).filter(d => d.isActive);
        this.campiUtenteStorici = (defs ?? []).filter(d => !d.isActive);
      })
      .catch(() => this.saveMessage.messageError('Ci sono problemi con il caricamento dei campi utente.'));

    if (!this.isEsolverOrg) return;
    this.campiUtenteService.getCampiUtenteDoc(orgId, this.ordine.idDocumento)
      .then(result => {
        const valori: Record<string, string> = {};
        // Prima i valori di testata (idRigaDoc 0), poi quelli della riga corrente che prevalgono.
        const rows = (result?.result ?? []).filter(r => r.idRigaDoc === 0 || r.idRigaDoc === this.ordine.idRiga);
        rows.sort((a, b) => a.idRigaDoc - b.idRigaDoc);
        for (const r of rows) valori[r.codiceCampoUtente.trim()] = r.valore?.trim() ?? '';
        this.valoriEsolverDoc = Object.keys(valori).length > 0 ? valori : null;
      })
      .catch(() => { this.valoriEsolverDoc = null; }); // best-effort: hint semplicemente assente
  }

  // Salvataggio sincrono dei campi utente PRIMA del flusso ordine (validazione strict backend):
  // errore → toast e abort del salvataggio/invio. I campi utente appartengono alla singola fase.
  private async saveCampiUtente(): Promise<boolean> {
    // Form visibile → serializza i valori correnti; form distrutto (altro tab) → usa il JSON
    // consolidato dal setter di currentTab; mai renderizzato → niente da salvare.
    const json = this.campiUtenteForm
      ? (this.campiUtenteForm.serialize() ?? '{}')
      : this.pendingCampiUtente;
    if (json === undefined) return true;
    try {
      await this.localService.updateOrdineCampiUtente({
        orgId: this.ordine.organizzazioneId,
        idDocumento: this.ordine.idDocumento,
        idRiga: this.ordine.idRiga,
        idRigaLavorazione: this.ordine.idRigaLavorazione,
        campiUtente: json,
      });
      this.ordine.campiUtente = json;
      return true;
    } catch (err) {
      const msg = (err as { error?: { errorMessage?: string } })?.error?.errorMessage
        ?? 'Ci sono problemi con il salvataggio dei campi utente.';
      this.saveMessage.messageError(msg);
      return false;
    }
  }

  /**
   * Quanto partirebbe verso ESOLVER con le quantità `q`: Locale − Inviata, secondo la modalità scarto.
   * Ri-basa `ordine.quantitaLavorata` sul valore ESOLVER (idempotente, vedi lo spec del componente).
   */
  private deltaAvanzamento(q: QuantitaModale): number {
    if (this.ordine.quantita - this.ordine.qtaRimanente !== (this.ordine.quantitaLavorata + this.ordine.quantitaNonConforme) - (this.scartoMode === 1 ? this.ordine.quantitaScartata : 0)) {
      this.ordine.quantitaLavorata = this.ordine.quantita - this.ordine.qtaRimanente + (this.scartoMode === 1 ? this.ordine.quantitaScartata : 0);
    }
    const quantitaLavorataWait = +q.aggQtaLav - this.ordine.quantitaLavorata;
    const quantitaScartataWait = +q.aggQtaScar - this.ordine.quantitaScartata;
    const quantitaNonConformeWait = +q.aggQtaNc - this.ordine.quantitaNonConforme;
    if (this.scartoMode === 1) {
      return (quantitaLavorataWait + quantitaNonConformeWait) - quantitaScartataWait;
    }
    return quantitaLavorataWait + quantitaNonConformeWait;
  }

  private leggiQuantita(): QuantitaModale {
    return {
      aggQtaLav: this.aggQtaLav, aggQtaLavUdM2: this.aggQtaLavUdM2,
      aggQtaScar: this.aggQtaScar, aggQtaScarUdM2: this.aggQtaScarUdM2,
      aggQtaNc: this.aggQtaNc, aggQtaNcUdM2: this.aggQtaNcUdM2
    };
  }

  private applicaQuantita(q: QuantitaModale): void {
    this.aggQtaLav = q.aggQtaLav;
    this.aggQtaLavUdM2 = q.aggQtaLavUdM2;
    this.aggQtaScar = q.aggQtaScar;
    this.aggQtaScarUdM2 = q.aggQtaScarUdM2;
    this.aggQtaNc = q.aggQtaNc;
    this.aggQtaNcUdM2 = q.aggQtaNcUdM2;
  }

  /** `null` = lettura non riuscita, distinta dall'elenco vuoto. Solo la fase in modifica fa da riferimento. */
  private leggiFasiPrecedenti(): Promise<FasePrecedenteAperta[] | null> {
    const fase: FaseCorrenteRef = {
      idDocumento: this.ordine.idDocumento,
      idRiga: this.ordine.idRiga,
      idRigaLavorazione: this.ordine.idRigaLavorazione,
      numFase: this.ordine.numFase
    };
    return this.avanzamentoService.getFasiPrecedentiAperte(this.organizzazioniService.organizzazioneId, [fase])
      .then(result => result?.hasErrors ? null : (result?.result ?? []))
      .catch(() => null);
  }

  private avvisaElencoNonDisponibile(fasi: FasePrecedenteAperta[] | null): void {
    if (fasi === null) {
      this.saveMessage.messageWarning('Non è stato possibile leggere le righe/fasi precedenti.');
      return;
    }
    this.saveMessage.messageInfo('Nessuna riga/fase a monte aperta.');
  }

  /**
   * L'interruttore implica «Termina fase» (la procedura termina prima la fase corrente) e riporta le
   * quantità ai valori letti: la chiusura non invia quantità digitate (research D-1, D-2).
   */
  private attivaInterruttore(fasi: FasePrecedenteAperta[]): void {
    this.statoPrimaInterruttore = {
      aggTerminato: this.aggTerminato,
      aggStato: this.aggStato,
      statoPrimaDelTerminato: this.statoPrimaDelTerminato,
      aggElimina: this.aggElimina,
      autoEliminaByTarget: this.autoEliminaByTarget,
      autoEliminaByStato: this.autoEliminaByStato,
      quantita: this.leggiQuantita()
    };
    this.fasiPrecedenti = fasi;
    this.fasiPrecedentiSelezionate = chiaviPreselezionate(fasi);
    this.applicaQuantita(this.quantitaLette);
    this.updateTerminato(true);
  }

  private ripristinaDaInterruttore(): void {
    const prima = this.statoPrimaInterruttore;
    this.aggTerminatoRiga = false;
    this.fasiPrecedenti = [];
    this.fasiPrecedentiSelezionate = [];
    this.statoPrimaInterruttore = null;
    if (!prima) {
      return;
    }
    this.aggTerminato = prima.aggTerminato;
    this.aggStato = prima.aggStato;
    this.statoPrimaDelTerminato = prima.statoPrimaDelTerminato;
    this.aggElimina = prima.aggElimina;
    this.autoEliminaByTarget = prima.autoEliminaByTarget;
    this.autoEliminaByStato = prima.autoEliminaByStato;
    this.applicaQuantita(prima.quantita);
  }

  /**
   * ⛔ Nessun `updateOrdine` qui: accoda una riscrittura dell'ordine su una coda diversa da quella delle
   * scritture di fine, e potrebbe riaprire la fase dopo la chiusura (analysis A-1). Il gruppo si costruisce
   * dalla fase riletta dal server.
   */
  private async inviaConFasiPrecedenti(): Promise<void> {
    const fase = await this.rileggiFase();
    if (!fase) {
      this.loading = false;
      return;
    }
    const userName = this.organizzazioniService.codiceOperatore ?? this.authService.currentUserValue.userName;
    await this.avanzamentoService.invioFineGroupConPrecedenti(this.organizzazioniService.organizzazioneId,
      Math.floor(this.dataOrdine.getTime() / 1000), this.buildOrdineGroupFase(fase),
      this.organizzazioniService.chiudiQtaFine, userName, this.fasiPrecedentiSelezionate)
      .then((result: FineConPrecedentiResult) => this.gestisciEsitoChiusura(result))
      .catch(() => this.chiudiConErroreFine())
      .finally(() => this.loading = false);
  }

  /** La fase da chiudere com'è sul server: `lastFase` da ESOLVER, quantità locali vere, stato attuale. */
  private async rileggiFase(): Promise<Ordine | null> {
    let fase: Ordine | null;
    try {
      fase = await this.localService.getOrdiniTempoAsync(this.ordine.organizzazioneId, this.ordine.idDocumento,
        this.ordine.idRiga, this.ordine.idRigaLavorazione);
    } catch {
      fase = null;
    }
    const motivo = !fase ? 'Ci sono problemi con il caricamento dell\'ordine.'
      : fase.flgTerminato ? 'Fase già terminata: chiusura non inviata.'
        : fase.lastFase == null ? 'Ultima fase della riga non determinabile: chiusura non inviata.' : null;
    if (motivo) {
      this.saveMessage.messageError(motivo);
      return null;
    }
    return fase;
  }

  /**
   * Un gruppo di una sola fase, con la forma di `ChiusuraFasiPrecedentiService.BuildOrdineGroupPerFase`.
   * `skipSave` resta non valorizzato: a true il saldo partirebbe senza persistenza locale.
   */
  private buildOrdineGroupFase(fase: Ordine): OrdineGroup {
    return {
      organizzazioneId: fase.organizzazioneId,
      idDocumento: fase.idDocumento,
      idRiga: fase.idRiga,
      idRigaLavorazione: fase.idRigaLavorazione,
      numFase: fase.numFase,
      ordini: [fase],
      quantita: fase.quantita,
      quantitaLavorata: fase.quantitaLavorata,
      quantitaOrdinataUdM2: fase.quantitaOrdinataUdM2,
      rifLottoProdotto: fase.rifLottoProdotto,
      trasfCodMag: fase.trasfCodMag,
      trasfCodArea: fase.trasfCodArea,
      contenitori: fase.contenitori,
      boxScarico: fase.boxScarico
    } as OrdineGroup;
  }

  /** Il Termina può fallire restituendo un esito che dichiara la fase non chiusa, senza sollevare. */
  private gestisciEsitoChiusura(result: FineConPrecedentiResult): void {
    if (!result?.ordineGroup?.flgTerminato) {
      this.chiudiConErroreFine();
      return;
    }
    this.saveMessage.messageInfo('Fine registrata');
    const avviso = descriviFasiNonChiuse(result.precedenti);
    if (avviso) {
      this.saveMessage.messageWarning(avviso);
    }
    void this.modalCtrl.dismiss(true, 'send');
  }

  private chiudiConErroreFine(): void {
    this.saveMessage.messageError("Ci sono problemi con l'invio di fine.");
    void this.modalCtrl.dismiss(true, 'error');
  }

  private setupOrdineFields(): void {
    this.isEsolverOrg = !this.organizzazioniService.isStandalone();
    this.scartoMode = this.ordine?.risorsa?.scartoMode ? this.ordine.risorsa.scartoMode : 0;
    this.setOrdineField();
    this.loadArticoloCoeff();
  }

  private round(num: number, decimals: number): number {
    const factor = 10 ** decimals;
    return Math.round(num * factor) / factor;
  }

  private loadArticoloCoeff(): void {
    this.articoloCoeff = null;
    if (!this.ordine?.codiceArticolo || !this.ordine?.udM2) {
      return;
    }
    this.articoliService.searchCoeffOfArticolo(this.organizzazioniService.organizzazioneId, this.ordine.codiceArticolo,
      this.ordine.udM, this.ordine.udM2)
      .then((coeff: ArticoloCoeff) => this.articoloCoeff = coeff)
      .catch(() => this.articoloCoeff = null); // best-effort: coefficiente non disponibile → nessuna conversione automatica
  }

  private refreshAutoRemoveState(): void {
    this.canAutoRemoveFromMes = this.canRemoveFromMes(this.ordine);
    if (!this.canAutoRemoveFromMes) {
      this.autoEliminaByTarget = false;
      this.autoEliminaByStato = false;
      this.aggElimina = false;
      return;
    }

    const isTargetReached = this.ordine.quantitaLavorata + this.ordine.quantitaNonConforme >= this.ordine.quantita;
    this.autoEliminaByTarget = this.viewElimina && !this.ordine.flgTerminato && isTargetReached;
    this.syncAutoRemoveState();
  }

  private syncAutoRemoveState(): void {
    if (!this.ordine) {
      return;
    }
    this.autoEliminaByStato = this.viewElimina &&
      this.canAutoRemoveFromMes &&
      this.aggStato === StatoEnum.TERMINATO &&
      this.ordine.stato !== StatoEnum.TERMINATO;

    if (this.autoEliminaByTarget || this.autoEliminaByStato) {
      this.aggElimina = true;
    }
  }

  private canRemoveFromMes(ordine: Ordine): boolean {
    if (!ordine?.risorsa?.codice || ordine.risorsa.id <= 0 || ordine.risorsa.isActive === false) {
      return false;
    }
    // WorkerDelete implementa la rimozione reale solo per risorse DB_MSSQL (vedi Worker.DeleteService.WorkerDelete):
    // per ogni altro formato l'ordine resterebbe bloccato in STATO_DA_ELIMINARE senza mai essere rimosso.
    return ordine.risorsa.formato === 'DB_MSSQL';
  }
}
